import Notify from "devextreme/ui/notify";
//DBTables
import { useState } from "react";
import { ModuleTypeId } from "../../../types/DBTables";
import { UseFormReturn } from "react-hook-form";

import NumberEditor from "../../Global/Editors/NumberEditor";
import CheckboxEditor from "../../Global/Editors/CheckboxEditor";
import TextEditor from "../../Global/Editors/TextEditor";
import { useGlobalData } from "../../GlobalDataProvider";
import SelectEditor from "../../Global/Editors/SelectEditor";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { nameof } from "../../Global/Utils";
import { IModuleVentilationFTXochFTConfig, IModuleVentilationFTXochFTRound, IModuleVentilationRoundKanaler, IModuleVentilationRoundTidskanaler } from "../../../types/ModuleDatas";
import TidsKanalEditor from "./TidsKanalEditor";
import { WeekDayName } from "../../../types/module-type";
import notify from "devextreme/ui/notify";
import BFLNote from "../BFL/BFLNote";

interface IProps {
  module: IModuleRound;
  data: any;
  formHook: UseFormReturn;
}

const RoundVentilationS = ({ module, data, formHook }: IProps) => {
  return (
    <div>
      {/* <div className="col-lg-12">Ventilation S</div> */}

      {/********************  Uppmätta & avlästa temperaturer ventilationsaggregat  */}
      <div className="row ml-0 mt-4">
        <div style={{ margin: 20 }}>Ingen data behövs anges för att rondera självdragssystem -Var vänlig och gå vidare genom att klicka på "Klar"</div>
      </div>

      <BFLNote formHook={formHook} />
    </div>
  );
};

export default RoundVentilationS;
